import React from "react";
import {connect} from "react-redux";
import 'leaflet/dist/leaflet.css';
import actionTypes from "../../../store/actionTypes";
import {IStore} from "../../../store/reducers";
import axios from "axios";
import {userService} from "../../../services/UserService";
import config from '../../../config.json';
import {Button, FormControl, MenuItem, Paper, Select, TextField, Typography} from "@material-ui/core";
import {Add, Delete, Edit, ExpandLess, ExpandMore} from '@material-ui/icons';
import {INotificacion, IParcela} from "../../../types";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateUtils from "@date-io/moment";
import moment from "moment";


interface IProps {
    setUsuarios(usuarios: Record<string, Record<string, string|number>[]>): void
    NewUserDialog(callback: boolean):void
    notify(notification: INotificacion): void
    openConfirmacion(callback: string): void
    setPrincipalUsuarios(usuarios: string[]): void
    menu: boolean
    usuarios: Record<string, Record<string, string|number>[]>
    parcelas: IParcela[]
}

interface Istate {
    expanded: string
    edited_level: number
    edited_date: string
    edited_limite_ha: number
    edited_limite_n: number
}

const levelNames: Record<number, string> = {
    1: "Básico",
    2: "Avanzado",
    3: "Profesional",
    4: "Personalizado",
    5: "Administrador"
}

class GestionUsuarios extends React.Component<IProps, Istate> {

    state:Istate = {
        expanded: '',
        edited_level: 1,
        edited_date: "",
        edited_limite_ha: 0,
        edited_limite_n: 0
    }

    componentDidMount() {
        const url: string = config.url+`/get/all/usuarios`
        axios.get(
            url,
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then((res) => {
                let data = res.data as Record<string, Record<string, string|number>[]>

                for (let level of Object.keys(data)) {
                    for (let usuario of data[level]) {
                        let parcelas = []
                        for (let parcela of this.props.parcelas) {
                            if (parcela.propietario.split(',').includes(usuario["nombre"])) parcelas.push(parcela.id)
                        }
                        let parcelas_str = parcelas.join(',')

                        axios.get(
                            config.url+`/superficie/parcelas?parcelas=${parcelas_str}`,
                            {auth: {
                                    username: `${userService.getUser()}`,
                                    password: `${userService.getPass()}`
                                }})
                            .then((res2) => {
                                usuario["superficie_usada"] = res2.data.superficie
                                usuario["n_parcelas"] = parcelas.length
                            })
                            .catch(() => {
                                this.props.notify({message: "Error solicitando datos de usuarios", variant: 'error'})
                            })

                    }
                }
                this.props.setUsuarios(res.data as Record<string, Record<string, string>[]>)
            })
            .catch(() => {
                this.props.notify({message: "Error solicitando datos de usuarios", variant: 'error'})
            })
    }

    handleEdit = (edited_level: boolean) => {

        let limite_ha = this.state.edited_limite_ha
        let limite_parcelas = this.state.edited_limite_n

        if (this.state.edited_level === 1){
            limite_ha = 500
            limite_parcelas = 3
        }
        if (this.state.edited_level === 2){
            limite_ha = -1
            limite_parcelas = 10
        }
        if (this.state.edited_level === 3){
            limite_ha = -1
            limite_parcelas = 20
        }
        if (this.state.edited_level === 4 && edited_level){
            limite_ha = 500
            limite_parcelas = 3
        }
        if (this.state.edited_level === 5){
            limite_ha = -1
            limite_parcelas = -1
        }

        axios.post(
            config.url+'/modificar/usuario',
            {
                nombre: this.state.expanded,
                level: this.state.edited_level,
                fecha_creacion: this.state.edited_date,
                limite_ha: limite_ha,
                limite_parcelas: limite_parcelas
            },
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }
            })
            .then(() => {
                const url: string = config.url+`/get/all/usuarios`
                axios.get(
                    url,
                    {auth: {
                            username: `${userService.getUser()}`,
                            password: `${userService.getPass()}`
                        }})
                    .then((res) => {
                        this.props.notify({message: `Usuario ${this.state.expanded} editado con éxito`, variant: 'success'})
                        this.props.setUsuarios(res.data)

                        const level = this.state.edited_level
                        const nombre = this.state.expanded

                        this.setState({expanded: ""})

                        axios.get(
                            config.url+'/get/usuarios',
                            {auth: {
                                    username: `${userService.getUser()}`,
                                    password: `${userService.getPass()}`
                                }})
                            .then((res: { data: string[] }) => {
                                this.props.setPrincipalUsuarios(res.data)
                                this.componentDidMount()
                                for (let el of this.props.usuarios[level]) {
                                    if (el["nombre"] === nombre) {
                                        setTimeout(() => this.setState({
                                            expanded: el.nombre as string,
                                            edited_level: el.level as number,
                                            edited_date: el.fecha_creacion as string,
                                            edited_limite_ha: el.limite_ha as number,
                                            edited_limite_n: el.limite_parcelas as number
                                        }), 500)
                                    }
                                }

                            })
                            .catch(() => {
                                this.props.notify({message: "Error interno", variant: 'error'})
                            })

                    })
                    .catch(() => {
                        this.props.notify({message: "Error interno", variant: 'error'})
                    })
            })
            .catch(() => {
                this.props.notify({message: "Error interno", variant: 'error'})
            })
    }

    renderComponent = (user: Record<string, string|number>) => {
        if (this.state.expanded !== user.nombre) {
            return <Paper
                key={user.nombre}
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '80%',
                    marginTop: 10,
                    borderRadius: 10
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '25%',
                        alignItems: "center",
                        marginLeft: 30
                    }}
                >
                    <Typography style={{fontSize: 16, fontFamily: "Poppins"}}>Usuario:</Typography>
                    <Typography style={{fontSize: 16, fontWeight: "bold", marginLeft: 10, fontFamily: "Poppins"}}>{user.nombre}</Typography>
                </div>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '20%',
                        alignItems: "center",
                    }}
                >
                    <Typography style={{fontSize: 16, fontFamily: "Poppins"}}>Tipo:</Typography>
                    <Typography style={{fontSize: 16, fontWeight: "bold", marginLeft: 10, fontFamily: "Poppins"}}>
                        {levelNames[user.level as number]}
                    </Typography>
                </div>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '30%',
                        alignItems: "center",
                        marginLeft: 30
                    }}
                >
                    <Typography style={{fontSize: 16, fontFamily: "Poppins"}}>Fecha Inicio:</Typography>
                    <Typography style={{fontSize: 16, fontWeight: "bold", marginLeft: 10, fontFamily: "Poppins"}}>{user.fecha_creacion}</Typography>
                </div>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '20%',
                        alignItems: "center",
                        marginLeft: 30
                    }}
                >
                    <Typography style={{fontSize: 16, fontFamily: "Poppins"}}>Activo:</Typography>
                    <Typography style={{fontSize: 16, fontWeight: "bold", marginLeft: 10, fontFamily: "Poppins"}}>
                        {user.confirmado as number == 1?
                            "Sí"
                            :
                            "No"
                        }
                    </Typography>
                </div>

                <Button
                    variant={"outlined"}
                    color={"primary"}
                    style={{
                        borderRadius: 10,
                        borderStyle: "solid",
                        borderWidth: 3,
                        margin: 2
                    }}
                    onClick={() => {
                        this.setState({
                            expanded: user.nombre as string,
                            edited_level: user.level as number,
                            edited_date: user.fecha_creacion as string,
                            edited_limite_ha: user.limite_ha as number,
                            edited_limite_n: user.limite_parcelas as number
                        })
                    }}
                >
                    <ExpandMore color={"primary"}/>
                </Button>
            </Paper>
        } else {
            return <Paper
                key={user.nombre}
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '80%',
                    marginTop: 10,
                    borderRadius: 10
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '33%'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginTop: 10,
                            marginLeft: 30
                        }}
                    >
                        <Typography style={{fontSize: 16, fontFamily: "Poppins"}}>Usuario:</Typography>
                        <Typography style={{fontSize: 16, fontWeight: "bold", marginLeft: 10, fontFamily: "Poppins"}}>
                            {user.nombre}
                        </Typography>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginTop: 10,
                            marginLeft: 30
                        }}
                    >
                        <Typography style={{fontSize: 16, fontFamily: "Poppins"}}>Nombre:</Typography>
                        <Typography style={{fontSize: 16, fontWeight: "bold", marginLeft: 10, fontFamily: "Poppins"}}>
                            {user.nombre_usuario}
                        </Typography>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginTop: 10,
                            marginLeft: 30
                        }}
                    >
                        <Typography style={{fontSize: 16, fontFamily: "Poppins"}}>Apellidos:</Typography>
                        <Typography style={{fontSize: 16, fontWeight: "bold", marginLeft: 10, fontFamily: "Poppins"}}>
                            {user.apellidos}
                        </Typography>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginTop: 10,
                            marginLeft: 30
                        }}
                    >
                        <Typography style={{fontSize: 16, fontFamily: "Poppins"}}>e-mail:</Typography>
                        <Typography style={{fontSize: 16, fontWeight: "bold", marginLeft: 10, fontFamily: "Poppins"}}>
                            {user.email}
                        </Typography>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginTop: 10,
                            marginLeft: 30,
                            marginBottom: 10
                        }}
                    >
                        <Typography style={{fontSize: 16, fontFamily: "Poppins"}}>Teléfno:</Typography>
                        <Typography style={{fontSize: 16, fontWeight: "bold", marginLeft: 10, fontFamily: "Poppins"}}>
                            {user.telefono}
                        </Typography>
                    </div>
                </div>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '33%',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginTop: 10,
                            marginLeft: 30
                        }}
                    >
                        <Typography style={{fontSize: 16, fontFamily: "Poppins", width: 50}}>Fecha Inicio:</Typography>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: '100%',
                                marginLeft: 10,
                                maxWidth: 200,
                                justifyContent: "center"
                            }}
                        >
                            <MuiPickersUtilsProvider
                                locale={"es"}
                                utils={DateUtils}
                            >
                                <KeyboardDatePicker
                                    clearable
                                    value={this.state.edited_date.length !== 0? new Date(this.state.edited_date.split("-").reverse().join("-")) : null}
                                    onChange={(f) => {
                                        if (f !== null){
                                            this.setState({
                                                edited_date: f.format('DD-MM-YYYY')
                                            })
                                        }
                                    }}
                                    format="DD-MM-YYYY"
                                />
                            </MuiPickersUtilsProvider>
                        </div>

                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginTop: 10,
                            marginLeft: 30
                        }}
                    >
                        <Typography style={{fontSize: 16, fontFamily: "Poppins"}}>Activo:</Typography>
                        <Typography style={{fontSize: 16, fontWeight: "bold", marginLeft: 10, fontFamily: "Poppins"}}>
                            {user.confirmado as number == 1?
                                "Sí"
                                :
                                "No"
                            }
                        </Typography>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginTop: 5,
                            marginBottom: 10,
                            marginLeft: 30,
                            alignItems: "center"
                        }}
                    >
                        <Typography style={{fontSize: 16}}>Tipo:</Typography>

                        <FormControl>
                            <Select
                                style={{width: '100%', marginLeft: 10}}
                                value={this.state.edited_level}
                                onChange={(e) => {
                                    if (userService.getUser() === user.nombre) return
                                    this.setState({edited_level: e.target.value as 1 | 2 | 3 | 4 | 5})
                                }}
                            >
                                {userService.getUser() !== user.nombre?
                                    [1, 2, 3, 4, 5].map(level => <MenuItem key={level} value={level}>
                                        <Typography style={{fontSize: 16, fontWeight: "bold", fontFamily: "Poppins"}}>
                                            {levelNames[level]}
                                        </Typography>
                                    </MenuItem>)
                                    :
                                    [user.level as number].map(level => <MenuItem key={level} value={level}>
                                        <Typography style={{fontSize: 16, fontWeight: "bold", fontFamily: "Poppins"}}>
                                            {levelNames[level]}
                                        </Typography>
                                    </MenuItem>)
                                }
                            </Select>
                        </FormControl>
                    </div>

                </div>


                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '33%'
                    }}
                >

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginTop: 10,
                            marginLeft: 30,
                            marginBottom: 10,
                            alignItems: "center"
                        }}
                    >
                        <Typography style={{fontSize: 16, fontFamily: "Poppins"}}>Limite Superficie:</Typography>
                        {(user.level === 5 || user.level === 3 || user.level === 2) &&
                            <Typography style={{fontSize: 16, fontWeight: "bold", marginLeft: 10, fontFamily: "Poppins"}}>Sin límite</Typography>
                        }
                        {user.level === 1 &&
                            <Typography style={{fontSize: 16, fontWeight: "bold", marginLeft: 10, fontFamily: "Poppins"}}>500 Ha</Typography>
                        }
                        {user.level === 4 &&
                            <TextField
                                style={{
                                    width: 70,
                                    marginLeft: 10
                                }}
                                type="number"
                                value={this.state.edited_limite_ha}
                                onChange={e => {
                                    if (!isNaN(parseFloat(e.target.value))) {
                                        this.setState({edited_limite_ha: parseInt(e.target.value) })
                                    }
                                }}
                                inputProps={{style: {fontSize: 16, fontFamily: "Poppins", fontWeight: "bold"}}}
                                InputLabelProps={{style: {fontSize: 16, fontFamily: "Poppins", fontWeight: "bold"}}}
                            />
                        }
                        {user.level === 4 &&
                            <Typography style={{fontSize: 16, fontWeight: "bold", marginLeft: 10, fontFamily: "Poppins"}}>Ha</Typography>
                        }

                    </div>


                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginTop: 10,
                            marginLeft: 30,
                            marginBottom: 10
                        }}
                    >
                        <Typography style={{fontSize: 16, fontFamily: "Poppins"}}>Superficie en uso:</Typography>
                        <Typography style={{fontSize: 16, fontWeight: "bold", marginLeft: 10, fontFamily: "Poppins"}}>
                            {Math.round(user.superficie_usada as number*100)/100}
                        </Typography>
                        <Typography style={{fontSize: 16, fontFamily: "Poppins", fontWeight: "bold", marginLeft: 10}}>Ha</Typography>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginTop: 10,
                            marginLeft: 30,
                            marginBottom: 10,
                            alignItems: "center"
                        }}
                    >
                        <Typography style={{fontSize: 16, fontFamily: "Poppins"}}>Limite Parcelas:</Typography>
                        {user.level === 5 &&
                            <Typography style={{fontSize: 16, fontWeight: "bold", marginLeft: 10, fontFamily: "Poppins"}}>Sin límite</Typography>
                        }
                        {user.level === 1 &&
                            <Typography style={{fontSize: 16, fontWeight: "bold", marginLeft: 10, fontFamily: "Poppins"}}>3</Typography>
                        }
                        {user.level === 2 &&
                            <Typography style={{fontSize: 16, fontWeight: "bold", marginLeft: 10, fontFamily: "Poppins"}}>10</Typography>
                        }
                        {user.level === 3 &&
                            <Typography style={{fontSize: 16, fontWeight: "bold", marginLeft: 10, fontFamily: "Poppins"}}>20</Typography>
                        }
                        {user.level === 4 &&
                            <TextField
                                style={{
                                    width: 70,
                                    marginLeft: 10
                                }}
                                type="number"
                                value={this.state.edited_limite_n}
                                onChange={e => {
                                    if (!isNaN(parseFloat(e.target.value))) {
                                        this.setState({edited_limite_n: parseInt(e.target.value) })
                                    }
                                }}
                                inputProps={{style: {fontSize: 16, fontFamily: "Poppins", fontWeight: "bold"}}}
                                InputLabelProps={{style: {fontSize: 16, fontFamily: "Poppins", fontWeight: "bold"}}}
                            />
                        }

                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginTop: 10,
                            marginLeft: 30,
                            marginBottom: 10
                        }}
                    >
                        <Typography style={{fontSize: 16, fontFamily: "Poppins"}}>Núm. Parcelas:</Typography>
                        <Typography style={{fontSize: 16, fontWeight: "bold", marginLeft: 10, fontFamily: "Poppins"}}>
                            {user.n_parcelas}
                        </Typography>
                    </div>

                </div>


                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <Button
                        variant={"outlined"}
                        color={"primary"}
                        style={{
                            borderRadius: 10,
                            borderStyle: "solid",
                            borderWidth: 3,
                            margin: 2,
                            height: "33%"
                        }}
                        onClick={() => {
                            this.setState({
                                expanded: '',
                                edited_date: '',
                                edited_level: 1,
                                edited_limite_ha: 0,
                                edited_limite_n: 0
                            })
                        }}
                    >
                        <ExpandLess color={"primary"}/>
                    </Button>

                    <Button
                        disabled={this.state.edited_limite_n === user.limite_parcelas && this.state.edited_limite_ha === user.limite_ha && this.state.edited_date === user.fecha_creacion && this.state.edited_level === user.level as number}
                        variant={"outlined"}
                        style={{
                            borderRadius: 10,
                            borderStyle: "solid",
                            borderWidth: 3,
                            borderColor: userService.getUser() === user.nombre || (this.state.edited_limite_n === user.limite_parcelas && this.state.edited_limite_ha === user.limite_ha && this.state.edited_date === user.fecha_creacion && this.state.edited_level === user.level as number)? "#aaaaaa" : "#44891f",
                            margin: 2,
                            height: "33%"
                        }}
                        onClick={() => this.handleEdit(this.state.edited_level !== user.level)}
                    >
                        <Edit
                            style={{
                                color: userService.getUser() === user.nombre || (this.state.edited_limite_n === user.limite_parcelas && this.state.edited_limite_ha === user.limite_ha && this.state.edited_date === user.fecha_creacion && this.state.edited_level === user.level as number)? "#aaaaaa" : "#44891f"
                            }}
                        />
                    </Button>

                    <Button
                        disabled={userService.getUser() === user.nombre}
                        variant={"outlined"}
                        style={{
                            borderRadius: 10,
                            borderStyle: "solid",
                            borderWidth: 3,
                            borderColor: userService.getUser() === user.nombre? "aaaaaa" : "#ce1931",
                            margin: 2,
                            height: "33%"
                        }}
                        onClick={() => this.props.openConfirmacion(this.state.expanded)}
                    >
                        <Delete
                            style={{
                                color: userService.getUser() === user.nombre? "#aaaaaa" : "#ce1931"
                            }}
                        />
                    </Button>
                </div>
            </Paper>
        }

    }

    render() {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#cccccc',
                    overflow: "auto"
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                <div
                    style={{
                        height: '100%',
                        width: this.props.menu? '18%': '5%'
                    }}
                />

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        height: '100%',
                        alignItems: "center",
                        width: this.props.menu? '82%': '95%'
                    }}
                >

                    <Button
                        variant={"contained"}
                        color={"primary"}
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            width: '80%',
                            height: 50,
                            marginTop: 30,
                            marginBottom:10,
                            borderRadius: 10
                        }}
                        onClick={() => this.props.NewUserDialog(true)}
                    >
                        <Add style={{width:50, height: 50, color: "white"}} />
                    </Button>

                    {Object.keys(this.props.usuarios).length > 0 &&
                        this.props.usuarios["5"].map((user) => this.renderComponent(user))
                    }
                    {Object.keys(this.props.usuarios).length > 0 &&
                        this.props.usuarios["4"].map((user) => this.renderComponent(user))
                    }
                    {Object.keys(this.props.usuarios).length > 0 &&
                        this.props.usuarios["3"].map((user) => this.renderComponent(user))
                    }
                    {Object.keys(this.props.usuarios).length > 0 &&
                        this.props.usuarios["2"].map((user) => this.renderComponent(user))
                    }
                    {Object.keys(this.props.usuarios).length > 0 &&
                        this.props.usuarios["1"].map((user) => this.renderComponent(user))
                    }

                </div>

            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    menu: state.navegacion.menu,
    usuarios: state.gestionUsuarios.usuarios,
    parcelas: state.principal.parcelas
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setUsuarios: (usuarios: Record<string, Record<string, string|number>[]>) => dispatch({type: "set-control-usuarios-usuarios", usuarios}),
    NewUserDialog: (callback: boolean) => dispatch({type: "open-new-user-dialog", callback}),
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    openConfirmacion: (callback: string) => dispatch({type: "open-confirmacion-eliminar-usuario-dialog", callback}),
    setPrincipalUsuarios: (usuarios: string[]) => dispatch({type: "set-principal-usuarios", usuarios})
});

export default connect(mapStateToProps, mapDispatchToProps)(GestionUsuarios);
